<template>
    <div class="shuttle-card">
        <div class="shuttle-card-content">
            <img class="card-head" :src="`/api/v1/file/${item.portrait}`" alt="">
            <div class="card-body">
                <div class="f-16 mb-6">{{item.nickname}}</div>
                <div class="f-14 color-grays mb-6">{{item.section1}} 注册时间：{{item.created_user}}</div>
                <div class="f-14 color-grays mb-6">{{item.name}} 标准{{item.seats}}座</div>
                <div class="mb-10" style="width: 100%;display: flex;justify-content: space-between">
                    <el-rate :value="+item.stars|| 0"
                              disabled
                              show-score
                              disabled-void-color="#cccccc"
                              text-color="#ff9900"
                              style="display: flex;justify-content: flex-start;align-items: center"
                              score-template="{value}"></el-rate>
                    <div class="f-14">{{item.comments||0}} 评价</div>
                </div>
                <div class="color-red f-20 mb-10">{{+item.price|parseMoney}}/车 <span class="f-16 color-black">{{item.seats-1}}人止</span></div>
                <el-button type="primary" @click="$emit('reserve')">预约</el-button>
            </div>
        </div>
        <div class="shuttle-card-line"></div>
        <div class="shuttle-card-content">
            <el-carousel class="gallery-top">
                <el-carousel-item class="gallery-top" v-for="(it,index) in item.image" :key="index">
                    <div style="width: 100%;height: 100%;display: flex;justify-content: center;align-items: center">
                        <img class="swiper-img" :preview="`shuttle${item.id}`" :src="`/api/v1/file/${it}`" alt="">
                    </div>
                </el-carousel-item>
            </el-carousel>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ShuttleCard",
        props: {
            item: {
                type: Object,
                default() {
                    return {}
                }
            },
        },
        data() {
            return {
                swiperOptionTop: {
                    loop: true,
                    loopedSlides: 5, // looped slides should be the same
                    spaceBetween: 10
                },
            }
        },
        computed:{
            srcList(){
                if(this.item.image&&this.item.image.length){
                    return this.item.image.reduce((ary, item)=>{
                        ary.push(`/api/v1/file/${item}`)
                        return ary
                    }, [])
                }
                return []
            }
        }
    }
</script>

<style scoped lang="less">
    .shuttle-card {
        width: 100%;
        height: 230px;
        padding: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        box-sizing: border-box;
        border-bottom: 1px solid #e2e2e2;
        &:last-child{
            border-bottom: none;
        }

        .shuttle-card-content {
            height: 100%;
            flex: 1;
            display: flex;
            justify-content: flex-start;
            align-items: flex-start;
            .card-head{
                width: 72px;
                height: 72px;
                border-radius: 100%;
                object-fit: cover;
                margin-right: 20px;
            }
            .card-body{
                text-align: left;
                .card-name{

                }
            }
        }

        .shuttle-card-line {
            width: 1px;
            background-color: #e2e2e2;
            height: 100%;
        }
    }
    .gallery-top{
        width: 430px;
        height: 190px;
        .swiper-slide{
            width: 100%;
            height: 100%;
        }
    }
    .swiper-img{
        display: block;
        width: 430px;
        /*height: 190px;*/
        object-fit: cover;
    }
</style>
